import { animate, AnimationBuilder, AnimationFactory, AnimationMetadata, AnimationPlayer, style } from '@angular/animations';
import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[appTransform]',
    standalone: false
})
export class TransformDirective {

	@Input()
	public timings: string | number = '200ms ease-in';

	@Input()
	public set rotate(value: string) {

		let splitValue: string[] = value.split(',');

		let animationMetadata: AnimationMetadata[] = [
			style(
				{
					transform: `rotate(${splitValue[0]}deg)`
				}
			),
			animate(
				this.timings,
				style(
					{
						transform: `rotate(${splitValue[1]}deg)`
					}
				)
			)
		]

		const factory: AnimationFactory = this._animationBuilder.build(animationMetadata);
		const player: AnimationPlayer = factory.create(this._elementRef.nativeElement);

		player.play();
	}

	constructor(
		private _elementRef: ElementRef,
		private _animationBuilder: AnimationBuilder
	) { }
}
